import { useFavoritesStore } from '~/stores/favorites'
import { useCartStore } from '~/stores/cartStore'

export default defineNuxtPlugin(nuxtApp => {
  // Using app:mounted hook ensures this runs after the app is mounted and initial rendering/hydration is complete.
  nuxtApp.hooks.hook('app:mounted', () => {
    if (process.client) {
      // console.log('[Plugin] App mounted, loading client state...');
      
      // Load Favorites
      const favoritesStore = useFavoritesStore();
      favoritesStore.loadClientState();
      
      // Load Cart
      const cartStore = useCartStore();
      cartStore.loadClientState();
    }
  });

  // Alternatively, use page:finish if loading needs to happen after every page navigation
  /*
  nuxtApp.hooks.hook('page:finish', () => {
    if (process.client) {
      console.log('[Plugin] Page finished, loading favorites from localStorage...');
      const favoritesStore = useFavoritesStore();
      favoritesStore.loadClientState();
    }
  });
  */
}); 